<template>
  <div>
    <!-- top search bar -->
    <div class="pa-5 d-flex">
      <div class="form-input-group flex-grow-1 mr-5">
        <div class="prepend-icon" style="top: 45%;">
          <v-icon>search</v-icon>
        </div>
        <input
          type="text"
          class="pl-42px"
          placeholder="搜尋"
          v-model="filter.keyword"
        />
      </div>
      <button class="btn btn-primary w-88px" @click="getAwards">搜尋</button>
    </div>

    <!-- second bar -->
    <div class="px-5 mb-5 d-flex">
      <SimpleSelectWithSearchInput
        class="mr-5"
        buttonPlaceholder="篩選國家"
        :isOnlyShowButtonPlaceholder="true"
        buttonWidth="160px"
        modalWidth="200px"
        :options="countries"
        :selectedValue.sync="filter.countryId"
        item-text="name"
        item-value="id"
      ></SimpleSelectWithSearchInput>
      <SimpleSelectWithSearchInput
        class="mr-5"
        buttonPlaceholder="篩選產品名稱"
        :isOnlyShowButtonPlaceholder="true"
        buttonWidth="160px"
        modalWidth="200px"
        :options="productOptions"
        :selectedValue.sync="filter.productId"
        item-value="id"
        item-text="text"
      ></SimpleSelectWithSearchInput>
      <SimpleSelectWithSearchInput
        class="mr-5"
        buttonPlaceholder="篩選Award Type"
        :isOnlyShowButtonPlaceholder="true"
        buttonWidth="160px"
        modalWidth="200px"
        :options="awardTypeOptions"
        :selectedValue.sync="filter.type"
      ></SimpleSelectWithSearchInput>
      <FilterAwardMonthStartEnd
        @update:selectedOption="filterTime = $event"
      ></FilterAwardMonthStartEnd>
    </div>

    <!-- filter condition -->
    <div
      class="px-5 mb-5 d-flex"
      v-if="
        filter.countryId != '' ||
        filter.productId != '' ||
        filter.type != '' ||
        filterTime != null
      "
    >
      <div
        class="h5 ink-02-medium--text h-32px w-70px d-flex align-center flex-shrink-0"
      >
        篩選條件：
      </div>
      <div class="flex-wrap">
        <!-- filter.country -->
        <v-chip
          v-if="filter.countryId != ''"
          close
          class="ml-5 mb-2"
          @click:close="filter.countryId = ''"
        >
          {{ countryName }}
        </v-chip>

        <!-- filter.product -->
        <v-chip
          v-if="filter.productId != ''"
          close
          class="ml-5 mb-2"
          @click:close="filter.productId = ''"
        >
          {{ productName }}
        </v-chip>

        <!-- filter.awardType -->
        <v-chip
          v-if="filter.type != ''"
          close
          class="ml-5 mb-2"
          @click:close="filter.type = ''"
        >
          {{ typeName }}
        </v-chip>

        <!-- filter subcategory -->
        <v-chip
          v-if="filterTime != null"
          close
          class="ml-5 mb-2"
          @click:close="filterTime = null"
        >
          {{ rangeTimeName }}
        </v-chip>
      </div>
    </div>

    <!-- table -->
    <v-simple-table>
      <template v-slot:default>
        <thead>
        <div v-if="lengthOfisCheckedList > 0"
             class="form-item d-flex align-center px-5 h-60px batch">
          <h5 class="col-checkbox">
            <v-checkbox
              v-model="checkAllStatus"
              :indeterminate="indeterminate"
              @click="changeAllCheckbox"
            ></v-checkbox>
          </h5>
          <h5 class="mr-22px">{{ lengthOfisCheckedList }} 項已選取</h5>
          <div>
            <button class="btn btn-danger mr-10px" @click="multiDelete">
              <v-icon color="white" class="mr-2">delete</v-icon>
              <span>刪除</span>
            </button>
          </div>
        </div>
        <tr>
          <th>
            <v-checkbox
              v-model="checkAllStatus"
              :indeterminate="indeterminate"
              @click="changeAllCheckbox"
            ></v-checkbox>
          </th>
          <th class="text-left">IMG</th>
          <th class="text-left">Award Name</th>
          <th class="text-left">Award Type</th>
          <th class="text-left">Year</th>
          <th class="text-left">Month</th>
          <th class="text-left">Award Country</th>
          <th class="text-left">編輯</th>
          <th class="text-left">刪除</th>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="item in awards"
          :key="item.id"
        >
          <td>
            <v-checkbox v-model="item.isChecked"></v-checkbox>
          </td>
          <td>
            <div
              class="w-40px h-40px bg-cover bg-center"
              :style="{
                  'background-image': `url(${item.image})`,
                }"
            ></div>
          </td>
          <td>
            <div>{{ item.title }}</div>
            <div class="ink-02-medium--text mt-1">
              {{ item.product_model_name }}
            </div>
          </td>
          <td>{{ item.type }}</td>
          <td>{{ item.year }}</td>
          <td>{{ item.month }}</td>
          <td>{{ item.country }}</td>
          <td>
            <button class="btn square" @click="toAwardEdit(item.id)">
              <v-icon>edit</v-icon>
            </button>
          </td>
          <td>
            <deleteDialog @confirm-delete="deleteItem(item.id)"></deleteDialog>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <!-- table footer -->
    <Pagination @handleNextPreEvent="getAwards" model="award"></Pagination>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import SimpleSelectWithSearchInput from '@/components/Selection/SimpleSelectWithSearchInput.vue';
import FilterAwardMonthStartEnd from '@/views/D_Awards/c/D-1a-AwardsList-FilterAwardMonthStartEnd.vue';
import Pagination from '@/components/Pagination.vue';
import deleteDialog from '@/components/C-1b__CategoriesList_Dialog-ConfirmDelete.vue';

export default {
  components: {
    SimpleSelectWithSearchInput,
    FilterAwardMonthStartEnd,
    Pagination,
    deleteDialog,
  },
  data: () => ({
    productOptions: [],
    filterTime: null,
    checkAllStatus: false, // left top checkbox status
  }),
  computed: {
    ...mapState('language', ['countries']),
    ...mapState('award', ['awards', 'filter', 'awardTypeOptions']),
    lengthOfisCheckedList() {
      return this.awards.filter((item) => item.isChecked)
        .length;
    },
    indeterminate() {
      const isCheckedList = this.awards.filter(
        (item) => item.isChecked,
      );
      if (
        isCheckedList.length === 0 ||
        isCheckedList.length === this.awards.length
      ) {
        return false;
      }
      return true;
    },
    isCheckedListIds() {
      return this.awards.filter((item) => item.isChecked).map((item) => item.id);
    },
    countryName() {
      const country = this.countries.find((item) => item.id === this.filter.countryId);
      return country.name || '';
    },
    productName() {
      const product = this.productOptions.find((item) => item.id === this.filter.productId);
      return product.text || '';
    },
    typeName() {
      const type = this.awardTypeOptions.find((item) => item.value === this.filter.type);
      return type.text || '';
    },
    rangeTimeName() {
      const { filterTime } = this;
      const start = `${filterTime.yearStartAt}.${filterTime.monthStartAt}`;
      const end = `${filterTime.yearEndAt}.${filterTime.monthEndAt}`;
      return `${start} ~ ${end}`;
    },
  },
  async created() {
    this.productOptions = await this.getProductOptions();
  },
  watch: {
    lengthOfisCheckedList(newValue) {
      if (newValue < this.awards.length) {
        this.checkAllStatus = false;
      }
      if (newValue === this.awards.length) {
        this.checkAllStatus = true;
      }
    },
    filterTime(newValue) {
      // 轉全月份篩選
      this.filter.time = newValue;
    },
  },
  methods: {
    ...mapActions('award', {
      getAwards: 'find',
      destroyAward: 'destroy',
      clear: 'clear',
    }),
    ...mapActions('product', ['getProductOptions']),
    toAwardEdit(id) {
      this.$router.push({
        name: 'AwardEdit',
        params: { id },
      });
    },
    changeAllCheckbox() {
      if (this.checkAllStatus) {
        this.awards.forEach(
          (item) => (item.isChecked = true),
        );
      } else {
        this.awards.forEach(
          (item) => (item.isChecked = false),
        );
      }
    },
    async deleteItem(id) {
      this.clear();
      await this.destroyAward(id).then(() => {
        this.getAwards();
      });
    },
    async multiDelete() {
      await this.isCheckedListIds.forEach((id) => {
        this.destroyAward(id).then(() => {});
      });
      this.getAwards();
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  .col-img {
    width: 40px;
    margin-right: 20px;
  }
  .col-award-name {
    width: 280px;
    margin-right: 15px;
  }
  .col-award-type {
    width: 100px;
    margin-right: 80px;
    text-align: center;
  }
  .col-year {
    width: 32px;
    margin-right: 80px;
    text-align: center;
  }
  .col-month {
    width: 45px;
    margin-right: 64px;
    text-align: right;
  }
  .col-location {
    width: 60px;
    margin-right: 40px;
    text-align: center;
  }
}
</style>
